export default __webpack_public_path__ + "static/media/dialog-futuristic-secondary-fbg.0b04984c.svg";